module.exports = __webpack_public_path__ + "img/other_xiaomi2.92d0a7ed.jpg";